// src/components/common/DraftStatusModal.jsx
import FullScreenOverlay from "../FullScreenOverlay";

export default function DraftCreationStatus({
  visible,
  status, // "success" or anything else
  nhsNumber,
  onClose,
}) {
  if (!visible) return null;

  const isSuccess = status === "success";
  const title = isSuccess
    ? "Draft Care Plan Created"
    : "Draft Care Plan Existing";
  const message = isSuccess
    ? `You’ve successfully created the Draft Care Plan ${nhsNumber}. You can view it under Draft Care Plans.`
    : `There is a draft care plan for this active care plan ${nhsNumber}. You can access it under draft care plan section.`;

  return (
    <FullScreenOverlay
      width="20%"
      height="20%"
      isPopup
      popupType={isSuccess ? "save" : "info"}
      buttons={[{ label: "OK", onClick: onClose, variant: "primary" }]}
    >
      <h5 className="semi-bold">{title}</h5>
      <p>{message}</p>
    </FullScreenOverlay>
  );
}
